// extracted by mini-css-extract-plugin
export default {"container":"_401_container__AFgUY","card":"_401_card__HoDN0","btn":"_401_btn__8ScKI"};